import { permissionManager } from "../PermissionManager/PermissionManager";
/**
    Password protect
    Remove security
    Redaction -> Mark Text to redaction
    Redaction -> Mark Area to redaction
    Redaction -> Mark Page to redaction
    Apply redaction
    Search & Redact
 */

export const PROTECT_HIDDEN_DATA_SANITIZE_DOCUMENT = 'hidden-data-sanitize-document';
export const PROTECT_HIDDEN_DATA_REMOVE_HIDDEN_INFORMATION = 'hidden-data-remove-hidden-information';

export const PROTECT_PDF_SIGN_DRAW_SIGNATURE = 'create-signature-btn';
export const SIGNATURE_LIST = 'signature-list';
export const INKSIGN_ADDED = 'inkSignAdded';
export const PROTECT_INKSIGN_ADD_TO_PAGE = 'imageAdded'
export const PROTECT_INKSIGN_DELETED = 'inkSignDeleted'

export const PROTECT_DIGITAL_IDS = 'digital-ids-btn';

export const PROTECT_PASSWORD_PROTECT = 'password-protect-btn'
export const PROTECT_CERTIFICATE_PROTECT = 'certificate-protect-btn'
export const PROTECT_SECURITY_POLICIES = 'security-policies-btn'
export const PROTECT_REMOVE_PROTECT = 'remove-protect-btn'
export const PROTECT_SECURITY_PROPERTIES = 'security-properties-btn'

export const PROTECT_CREATE_TEXT_IMAGE_REDACT = 'create-text-image-redaction'
export const PROTECT_CREATE_AREA_REDACT = 'create-area-redaction'
export const PROTECT_CREATE_PAGE_REDACT = 'create-page-redaction'
export const PROTECT_REDACT_APPLY = 'redaction-apply'
export const PROTECT_REDACT_SEARCH ='redaction-search'

export const PROTECT_VALIDATE_DOC = 'validate-doc-button';

export const PROTECT_LIST = [
    PROTECT_HIDDEN_DATA_SANITIZE_DOCUMENT,
    PROTECT_HIDDEN_DATA_REMOVE_HIDDEN_INFORMATION,
    SIGNATURE_LIST,
    PROTECT_PDF_SIGN_DRAW_SIGNATURE,
    PROTECT_PASSWORD_PROTECT,
    PROTECT_REMOVE_PROTECT,
    PROTECT_CREATE_TEXT_IMAGE_REDACT,
    PROTECT_CREATE_AREA_REDACT,
    PROTECT_CREATE_PAGE_REDACT,
    PROTECT_REDACT_APPLY,
    PROTECT_REDACT_SEARCH,
    PROTECT_VALIDATE_DOC
]
// premium features
export const PROTECT_PREMIUM_BTNS = [
    PROTECT_PASSWORD_PROTECT,
    PROTECT_CERTIFICATE_PROTECT,
    PROTECT_SECURITY_POLICIES,
    PROTECT_DIGITAL_IDS,
    PROTECT_HIDDEN_DATA_SANITIZE_DOCUMENT,
    PROTECT_HIDDEN_DATA_REMOVE_HIDDEN_INFORMATION,
    PROTECT_REMOVE_PROTECT,
    PROTECT_SECURITY_PROPERTIES,
    PROTECT_CREATE_TEXT_IMAGE_REDACT,
    PROTECT_CREATE_AREA_REDACT,
    PROTECT_CREATE_PAGE_REDACT,
    PROTECT_REDACT_APPLY,
    PROTECT_REDACT_SEARCH,
    PROTECT_VALIDATE_DOC,
];
permissionManager.registerPremiumFeatures(PROTECT_PREMIUM_BTNS);